import React from 'react';
import { Navbar } from 'flowbite-react';
import type { TabItem, TabsComponentProps } from './tabs';
import { navTabsTheme } from '../../styles/themes/navTabs';

export type NavTabItem = TabItem & { href: string };

export type NavTabsComponentProps = Omit<TabsComponentProps, 'items' | 'variant'> & {
    items: NavTabItem[];
    showSelectedStyle?: boolean;
};

export const NavTabsComponent: React.FC<NavTabsComponentProps> = (props) => {
    const { items, handleChange, selectedTab, showSelectedStyle = true, className } = props;
    const isSelectedTab = (i: number) => i === selectedTab;
    return (
        <Navbar
            theme={navTabsTheme}
            className={`${className} bg-system-surface border-b border-system-outline-variant font-sans`}
        >
            {/* optional, for further development */}
            {/* <Navbar.Brand href='#'>
            {/* render hamburger button on mobile */}
            {/* <Navbar.Toggle /> */}

            {/* can be hidden conditionally via theme */}
            <Navbar.Collapse>
                {items.map((item: NavTabItem, i: number) => (
                    <Navbar.Link
                        key={i}
                        as={'a'} // Using standard anchor tag for navigation
                        href={item.href} // nav target can be page section or full url
                        onClick={() => handleChange(i)} // state updates and more
                        className={`${
                            isSelectedTab(i) && showSelectedStyle
                                ? 'border-system-secondary text-system-on-surface'
                                : 'border-transparent text-system-on-surface-variant hover:rounded-lg hover:primary-hover-state'
                        } border-b-4 hover:text-system-on-surface font-sans text-sm font-medium inline-flex h-12 min-w-[72px] justify-center items-center shrink-0`}
                    >
                        {item.label}
                    </Navbar.Link>
                ))}
            </Navbar.Collapse>
        </Navbar>
    );
};
